import { useRPC } from "../../../hooks/useRPC/index.js";
import { RPCs } from "@therms/rpc-gateway";
//#region src/modules/Locations/hooks/useLocationLogEntryType.ts
/**
* Get a single LocationLogEntryType details
* @param args
* @param opts
*/
function useLocationLogEntryType(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Locations.GetLocationLogEntryType.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args?.entryTypeId
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useLocationLogEntryType };

//# sourceMappingURL=useLocationLogEntryType.js.map